module.exports = __webpack_public_path__ + "img/kitesurfen--white.5b45111f.svg";